import React, {useEffect} from 'react'
import {OnboardingActivationStatus} from '@modifi/enums'
import {Col, InfoAlert, InlineLoader, Row} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import {
  PRE_UNDERWRITING,
  PRE_UNDERWRITING_STEPS,
  preunderwritingSubmitStateKeyPrefix,
} from './constants'
import {ProgressLayout} from '../index'
import PreUnderwritingContent from './pre-underwriting-content/PreUnderwritingContent'
import {userPreferences} from '../../../utils/user-preferences'

export type PreUnderwritingContainerProps = {
  activationStatus?: string
  redirectToOnboarding?: () => void
  isCompanyLocked?: boolean
  companyExternalId?: string
}

const PreUnderwritingContainer: React.FC<PreUnderwritingContainerProps> = ({
  activationStatus = OnboardingActivationStatus.INCOMPLETE,
  redirectToOnboarding,
  isCompanyLocked = false,
  companyExternalId,
}) => {
  const {t} = useTranslation('charon')
  const preunderwritingSubmitStateKey = `${preunderwritingSubmitStateKeyPrefix}:${companyExternalId}`
  useEffect(() => {
    if (
      activationStatus &&
      activationStatus !== OnboardingActivationStatus.INCOMPLETE &&
      redirectToOnboarding
    ) {
      const hasUserSubmitedPreunderwriting = userPreferences.get(preunderwritingSubmitStateKey)
      if (hasUserSubmitedPreunderwriting === 'true' || hasUserSubmitedPreunderwriting !== 'false') {
        redirectToOnboarding()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activationStatus, redirectToOnboarding])

  if (userPreferences.get(preunderwritingSubmitStateKey) == null && companyExternalId) {
    userPreferences.set(preunderwritingSubmitStateKey, 'false')
  }

  if (!activationStatus || !companyExternalId) {
    return (
      <Row justifyContent="center">
        <Col auto>
          <InlineLoader />
        </Col>
      </Row>
    )
  }

  return (
    <ProgressLayout
      featureName={PRE_UNDERWRITING}
      progressSteps={PRE_UNDERWRITING_STEPS}
      companyExternalId={companyExternalId}
    >
      {!!isCompanyLocked && (
        <Row>
          <Col>
            <InfoAlert>{t('onboarding-dashboard.company-locked-alert')}</InfoAlert>
          </Col>
        </Row>
      )}
      <PreUnderwritingContent />
    </ProgressLayout>
  )
}

export default PreUnderwritingContainer
